import React, { createContext, useReducer, useContext } from "react";
import {
  MonthSalaryActions,
  monthSalaryInitState,
  MonthSalaryState,
  monthSalaryStateReducer,
} from "./monthSalaryStore.reducer";
import { monthSalaryActions } from "./monthSalaryStore.actions";

export type MonthSalaryDispatch = (action: MonthSalaryActions) => void;

const MonthSalaryStateContext = createContext<MonthSalaryState | undefined>(
  undefined
);
const MonthSalaryDispatchContext = createContext<
  MonthSalaryDispatch | undefined
>(undefined);

export const MonthSalaryStoreProvider: React.FC = ({ children }) => {
  const [state, dispatch] = useReducer(
    monthSalaryStateReducer,
    monthSalaryInitState
  );

  return (
    <MonthSalaryStateContext.Provider value={state}>
      <MonthSalaryDispatchContext.Provider value={dispatch}>
        {children}
      </MonthSalaryDispatchContext.Provider>
    </MonthSalaryStateContext.Provider>
  );
};

export const useMonthSalaryStore = () => {
  const state = useContext(MonthSalaryStateContext);
  const dispatch = useContext(MonthSalaryDispatchContext);

  if (state === undefined || dispatch === undefined) {
    throw new Error(
      "useMonthSalaryStore must be used within a MonthSalaryStoreProvider"
    );
  }

  const actions = monthSalaryActions(dispatch);
  return [state, actions, dispatch] as const;
};
